module.exports = __webpack_public_path__ + "img/tarj2-6.fa8a1f3f.svg";